import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

import VueSocialSharing from 'vue-social-sharing';
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "UA-178020000-1" }
});





 



import ToggleSwitch from 'vuejs-toggle-switch';
import Dialog from 'vue-dialog-loading';


Vue.use(Dialog, {
 dialogBtnColor: '#0f0'
})

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);
Vue.use(BootstrapVue);
Vue.use(VueSocialSharing);
Vue.use(IconsPlugin);
Vue.use(ToggleSwitch);



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
